import { httpRequest } from '@/services/httpClient'

export type RefDataItem = {
  id: number
  groupKey: string
  code: string
  displayName: string
  sortOrder: number
  isActive: boolean
}

export const refDataApi = {
  listByGroup: (groupKey: string) =>
    httpRequest<RefDataItem[]>('/v1/refdata', {
      method: 'GET',
      query: { groupKey, onlyActive: true },
    }),
}

